import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <>
      <div className="lg:px-[80px] px-[20px] md:pb-[58px] pb-[38px] md:pt-[26px] pt-0">
        <div className="grid lg:grid-cols-6 grid-cols-1 items-center lg:gap-[80px] md:gap-y-[30px] md:gap-x-0">
          <div className="col-span-2">
            <div className="flex flex-col md:items-start items-center">
              <Link to="/">
                <img src="../assets/home/logo.svg" alt="logo" className="md:pb-[10px] pt-[30px] pb-[12px]" />
              </Link>
              <p style={{ fontFamily: "DM sans, serif" }} className="font-[400] footer-des md:text-[16px] text-[13px] leading-[26px] md:pb-0 pb-[13px] text-[#263238] max-w-[407px] w-full">
                Study hard what interests you the most in the most undisciplined,
                irreverent and original manner possible.
              </p>
            </div>
          </div>
          <div className="col-span-4">
            <div className="flex md:gap-[40px] gap-[20px] justify-end">
              <a href="https://g.co/kgs/LJ2gVXX" target="_blank" rel="noopener noreferrer">
                <img src="/assets/footer/icon1.svg" alt="" />
              </a>
              <a href="https://www.facebook.com/people/GisulCommunity/61576707204734/" target="_blank" rel="noopener noreferrer">
                <img src="/assets/footer/icon2.svg" alt="" />
              </a>
              <a href="https://www.instagram.com/gisulcommunity/" target="_blank" rel="noopener noreferrer">
                <img src="/assets/footer/icon3.svg" alt="" />
              </a>
              <a href="https://www.linkedin.com/company/gisuledtech" target="_blank" rel="noopener noreferrer">
                <img src="/assets/footer/icon4.svg" alt="" />
              </a>
              <a href="https://www.youtube.com/@gisulcommunity" target="_blank" rel="noopener noreferrer">
                <img src="/assets/footer/icon5.svg" alt="" />
              </a>
              <a href="https://x.com/gisulcommunity" target="_blank" rel="noopener noreferrer">
                <img src="/assets/footer/icon6.svg" alt="" />
              </a>
            </div>
          </div>
        </div>
        <div className="pt-[40px] flex md:justify-start justify-center gap-[20px]">
          <Link to="/privacy-policy" className="font-roboto text-center font-[500] lg:text-[18px] text-[14px] leading-[26px] text-[#263238]">
            Privacy Policy
          </Link>
          <Link to="/terms&condition" className="font-roboto text-center font-[500] lg:text-[18px] text-[14px] leading-[26px] text-[#263238]">
            Terms & Condition
          </Link>
        </div>
      </div>
      <div className="border-t-[1px] border-[#96969666]">
        <p className="py-[17px] font-roboto text-center font-[500] text-[14px] leading-[26px] text-[#263238]">All Rights Reserved. Powered by GISUL </p>
      </div>
    </>
  );
}

export default Footer;
